import * as React from "react";

const SvgIcnDownload = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <path
            d="M14.5 15a.5.5 0 110 1h-9a.5.5 0 110-1h9zM10 2.5a.5.5 0 01.5.5v9.792l4.146-4.146a.5.5 0 01.708.708l-5 5-.042.037-.062.042-.06.03-.062.02-.056.012L10 14.5l-.053-.003-.075-.014-.063-.02-.076-.04-.055-.04-5.032-5.03a.5.5 0 11.708-.707L9.5 12.792V3a.5.5 0 01.5-.5z"
            fill="#121C2D"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnDownload;
